var isMobileView = function isMobileView() {
  return window.innerWidth < 576;
};

var hasMouseSupport = function hasMouseSupport() {
  return matchMedia('(pointer:fine)').matches;
};

var hasTouchSupport = function hasTouchSupport() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};

var isTouchOnlyDevice = function isTouchOnlyDevice() {
  return hasTouchSupport() && !hasMouseSupport();
};

export { hasMouseSupport, hasTouchSupport, isMobileView, isTouchOnlyDevice };